/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserAssignRoleRequest, UserAssignRoleResponse } from '../types/UserAssignRole'

/**
 * POST /users/assign-role
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::assignRole
 */
export async function userAssignRole(
	data: UserAssignRoleRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserAssignRoleResponse>> {
	return axiosInstance.post('/users/assign-role', data, config)
}
